export enum ProcessTrackingStatusEnum {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAIL = "FAIL"
}

